/**
 * Scroll a playing/target ayah into the reading viewport.
 *
 * Uses the TOP of the ayah card (not vertical center of the full card), so open
 * tafsir / tall WBW blocks do not push the verse content off-screen.
 * Places that top slightly above the middle of the visible reading area
 * (below the fixed header, above the sticky audio player).
 */

function readingChrome() {
  const header = document.querySelector('header');
  const audio = document.querySelector('.sticky-audio-player');
  const headerH = header ? header.getBoundingClientRect().height : 60;
  const audioH = audio ? audio.getBoundingClientRect().height : 0;
  const top = Math.max(0, headerH) + 8;
  const bottom = Math.max(top + 80, window.innerHeight - Math.max(0, audioH) - 8);
  return { top, bottom, height: bottom - top };
}

function resolveAyahElement(ayahKey) {
  if (!ayahKey) return null;
  const key = String(ayahKey);
  return (
    document.getElementById(`ayah-${key}`) ||
    document.getElementById(key) ||
    document.querySelector(`[data-ayah-id="${key}"]`)
  );
}

/**
 * @param {string} ayahKey e.g. "2:255"
 * @param {{ instant?: boolean, preferTopRatio?: number }} [opts]
 *   preferTopRatio — where the ayah top should sit in the visible reading band (0–1).
 *   Default 0.22 ≈ above center.
 */
export function scrollAyahIntoView(ayahKey, opts = {}) {
  const instant = opts.instant !== false;
  const preferTopRatio =
    typeof opts.preferTopRatio === 'number' ? opts.preferTopRatio : 0.22;

  const el = resolveAyahElement(ayahKey);
  if (!el) return false;

  const { top: viewTop, height: viewH } = readingChrome();
  const anchorY = viewTop + viewH * preferTopRatio;
  const rect = el.getBoundingClientRect();
  const delta = rect.top - anchorY;

  // Skip tiny adjustments (avoids jitter when already in place)
  if (Math.abs(delta) < 12) return true;

  const targetTop = Math.max(0, window.scrollY + delta);
  window.scrollTo({
    top: targetTop,
    behavior: instant ? 'auto' : 'smooth',
  });
  return true;
}

/**
 * Scroll now, then again after layout settles (tafsir expand, WBW, fonts).
 * @param {string} ayahKey
 * @param {{ instant?: boolean, preferTopRatio?: number }} [opts]
 */
export function scrollAyahIntoViewSettled(ayahKey, opts = {}) {
  const instant = opts.instant !== false;
  scrollAyahIntoView(ayahKey, opts);

  const delays = instant ? [80, 280] : [120, 400];
  delays.forEach((ms) => {
    setTimeout(() => {
      scrollAyahIntoView(ayahKey, { ...opts, instant: true });
    }, ms);
  });
}
